import * as React from 'react';
export function useOnChange(onChange) {
  return React.useCallback(function (event) {
    if (onChange) {
      onChange(event, event.target.value);
    }
  }, [onChange]);
}